/**
 * Converts linear index to [row, column] coordinates
 *
 * For a grid of given size, translates a flat array index
 * to its corresponding row and column position.
 *
 * @param {number} index - Linear index in the board array
 * @param {number} size - Board dimension (e.g., 3 for 3x3)
 * @returns {[number, number]} Tuple [row, column] (0-indexed)
 *
 * @example
 * // For a 3x3 board:
 * // [0][1][2]
 * // [3][4][5]
 * // [6][7][8]
 * indexToRC(0, 3)  // [0, 0] (top-left)
 * indexToRC(4, 3)  // [1, 1] (center)
 * indexToRC(8, 3)  // [2, 2] (bottom-right)
 * indexToRC(5, 3)  // [1, 2] (middle row, right column)
 */
export function indexToRC (index, size) {
  const r = Math.floor(index / size)
  const c = index % size
  return [r, c]
}
